.planSettings {
	padding-left: 0px;
	padding-right: 0px;
}

.planSettingsDivider {
	border-bottom: 1px solid var(--ds-border, var(--adg3-color-N40A));
	margin: 4px 0;
}
